<template>
  <div class="card">
    <header class="bandeau-modal card-header">
      <h1 class="title is-size-4 has-text-white mg-10px">
        {{ $t('connexion.resetPassword.title') }}
      </h1>
    </header>
    <div class="card-content">
      <error-msg-component
        :messages="messages"
        :messagesChampsVide="messagesChampsVide"
        :champsVide="champsVide"
        :error="isErrorPopup"
        :title="'general.problemOccurred'"
        :withEmplyFields="true"
        @close="isErrorPopup = $event"/>
      <form  @submit.prevent="envoyer()">
        <b-field :label="$t('connexion.popupMdpOublie.site')"
                  class="mgt-10px obligatoire" custom-class="has-text-default">
          <b-input v-model="site" name="organization" autocomplete="organization"></b-input>
        </b-field>

        <app-input-email :label="$t('connexion.popupMdpOublie.email')"
        class="obligatoire" v-model="email"/>

        <main class="column is-12 is-paddingless mgt-20px">
          <div class="has-text-right mgt-20px">
              <button
                class="button btn-modal-annuler is-cancel has-text-centered
                  button-modal"
                  type="button"
                @click="annuler()">
                {{$t('connexion.popupMdpOublie.cancel')}}
              </button>
              <button class="button is-primary has-text-centered button-modal mgr-0"
                  type="submit">
                {{$t('connexion.popupMdpOublie.envoyer')}}
              </button>
            </div>
        </main>
      </form>
    </div>
  </div>
</template>

<script>
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { requestReinitPwdCode } from '@/services/utilisateur/motdepasseoublie';
import validationMdpOublie from '@/services/connexion/mdpOublieMessageErreur';
import validation from '@/services/validation/validation';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import InputEmail from '@/components/general/inputEmail';

export default {
  name: 'popupMdpOublie',
  components: {
    errorMsgComponent,
    appInputEmail: InputEmail,

  },
  data() {
    return {
      email: '',
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      isErrorPopup: false,
    };
  },
  props: {
    site: {
      type: String,
      required: false,
      default: null,
    },
  },
  methods: {
    async envoyer() {
      this.isErrorPopup = false;
      const loadingComponent = this.$buefy.loading.open();
      try {
        await requestReinitPwdCode({
          site: this.site,
          emailAddress: this.email,
        });
        messageSucces(this.$t('connexion.popupMdpOublie.info.success'));
        loadingComponent.close();
        this.$emit('close');
      } catch (e) {
        if (e.response?.data.error) {
          this.messages = [];
          this.messagesChampsVide = [];
          this.champsVide = [];
          validation(this.$i18n, e.response, this.champsVide,
            this.messages,
            this.messagesChampsVide,
          );
          this.messages = validationMdpOublie(e.response, this.messages);
          this.isErrorPopup = true;
        } else {
          messageErreur(this.$i18n);
        }
        loadingComponent.close();
        throw e;
      }
    },
    annuler() {
      this.$emit('close');
    },
  },
};
</script>
